"use client";

import { useTranslations } from "next-intl";
import { useBoundStore } from "@/lib/stores/useBoundStore";
import { getEmeaEntity } from "@/lib/constants/emeaEntities";
import { LegalDocumentBody } from "../LegalDocumentBody";
import { lp, LegalPart } from "../helpers";

const PARTS: LegalPart[] = [
  lp.subtitle("subtitle"),
  lp.heading("general"),
  lp.paragraph("generalPara1"),
  lp.paragraph("generalPara2"),
  lp.paragraph("generalPara3"),
  lp.heading("ourRole"),
  lp.paragraph("ourRoleText"),
  lp.heading("whatDataCollected"),
  lp.paragraph("whatDataCollectedPara1"),
  lp.paragraph("whatDataCollectedPara2"),
  lp.paragraph("whatDataCollectedPara3"),
  lp.paragraph("whatDataCollectedPara4"),
  lp.heading("whoWeShare"),
  lp.paragraph("whoWeShareText"),
  lp.heading("retention"),
  lp.paragraph("retentionText"),
  lp.heading("yourRights"),
  lp.paragraph("yourRightsText"),
];

// EMEA Patient Privacy Policy. Reused by the /legal page and the patient
// enrollment (AcceptTerms) flow. Entity is resolved from the detected country.
export function EMEAPatientPrivacyContent() {
  const userCountry = useBoundStore((state) => state.userCountry);
  const t = useTranslations("emeaPatientPrivacyPolicy");
  return (
    <LegalDocumentBody
      t={t}
      titleKey="title"
      parts={PARTS}
      entity={getEmeaEntity(userCountry)}
    />
  );
}
